module.exports = __webpack_public_path__ + "static/media/campo4.d739a056.jpg";